import React from 'react';
import { useState, useEffect } from 'react';
import { Link, useLocation } from 'react-router-dom';
import CommonButtonComponent from '../components/CommonButton';
import collapsedMenuCloseIcon from '../../assets/icon/navbar-close-black.png';

import quizBlackLogo from '../../assets/icon/test-black.png';
import quizWhiteLogo from '../../assets/icon/test-white.png';

import './Navbar.css';

/**
 * NavBar component renders a navigation bar with links to different pages of the website.
 * The navigation bar changes its position and style based on the scroll position.
 * 
 * @param {Object} props - The component props.
 * @param {string} props.theme - The theme of the navigation bar. It can be either "light" or "dark".
 * 
 * @returns {JSX.Element} The rendered navigation bar component.
 */
export const NavBar = ({ theme }) => {
    const [activeLink, setActiveLink] = useState("home");
    const [scrolled, setScrolled] = useState(false);
    const [menuOpen, setMenuOpen] = useState(false);
    const location = useLocation();

    useEffect(() => {
        const onScroll = () => {
            let navbar = document.getElementsByClassName("navbar")[0];
            
            if (window.scrollY >= window.innerHeight - 20) {// 20px less than the height of the window
                setScrolled(true);
                navbar.style.position = "fixed";
                
            } else {
                setScrolled(false);
                navbar.style.position = "absolute";
            }
        }

        window.addEventListener("scroll", onScroll);

        return () => {
          window.removeEventListener("scroll", onScroll);
        }
    }, [])

    useEffect(() => {
        // Update active link based on the current path
        const path = location.pathname;
        if (path === "/") {
            setActiveLink("home");
        } else if (path.startsWith("/projects")) {
            setActiveLink("projects");
        } else if (path.startsWith("/services")) {
            setActiveLink("services");
        } else if (path.startsWith("/about")) {
            setActiveLink("about");
        } else if (path.startsWith("/blog")) {
            setActiveLink("blog");
        } else if (path.startsWith("/quiz")) {
            setActiveLink("quiz");
        }
    }, [location]);

    const onUpdateActiveLink = (value) => {
        setActiveLink(value);
    }

    const onMenuClick = () => {
        setMenuOpen(!menuOpen); // 切换菜单显示状态
    };
    
    const onMenuClose = () => {
        setMenuOpen(false); // 关闭菜单
    };

    const handleMenuClickAndUpdateLink = (link) => {
        onMenuClose();
        onUpdateActiveLink(link);
    };

    const navLinks = [
        { path: "/", label: "Home", key: "home" },
        { path: "/projects", label: "Projects", key: "projects" },
        { path: "/services", label: "Services", key: "services" },
        { path: "/about", label: "About", key: "about" },
        { path: "/blog", label: "Blog", key: "blog" }
    ];

    return (
        <nav className={`navbar ${scrolled ? "scrolled" : ""} ${theme === 'light' && !scrolled ? 'light' : 'dark'}`}>

            <div className='navbar-links__container--collapsed'>
                <div className={`menu-icon-container`} onClick={onMenuClick} >
                    {/* Each span represents 1 line in menu icon */}
                    <span></span>
                    <span></span>
                    <span></span>
                </div>
                    
                <span className={`menu-overlay ${menuOpen ? 'show' : ''}`} onClick={onMenuClose}></span>

                <div className={`navbar-links__collapsed-menu ${menuOpen ? 'show' : ''}`}>
                    <div className={`close-icon__container`} onClick={onMenuClick} >
                        <img src={collapsedMenuCloseIcon} alt="" />
                    </div>

                    {navLinks.map(link => (
                        <Link
                            key={link.key}
                            to={link.path}
                            className={`navbar-link--collapsed`}
                            onClick={() => handleMenuClickAndUpdateLink(link.key)}
                        >
                            {link.label}
                        </Link>
                    ))}
                </div>
            </div>
                
            <div className='logo'>
                <Link to="/">Hong Kong Architect</Link>
            </div>

            <div className='navbar-links__container--expended'>
                {navLinks.map(link => ( link.key !== 'home' &&
                    <Link
                        key={link.key}
                        to={link.path}
                        className={`navbar-link ${activeLink === link.key ? 'active' : ''}`}
                        onClick={() => onUpdateActiveLink(link.key)}
                    >
                        {link.label}
                    </Link>
                ))}
            </div>

            <div className='navbar-buttons__container'>
                <Link to="/quiz">
                    <div className='navbar-buttons-icon--collapsed'>
                        <img src={ `${theme === 'light' && !scrolled ? quizWhiteLogo : quizBlackLogo}`} alt="quiz icon black" />
                    </div>
                </Link>

                <Link to="/quiz">
                    <CommonButtonComponent customClass='quiz-button' size='large' presetStyle={`${theme === 'light' && !scrolled ? 'light' : 'dark'}`}>
                        Style Quiz
                    </CommonButtonComponent>
                </Link>
            </div>
        </nav>
    );
};